import React from 'react';
import './search-result-card.less';

export const SearchResultsDisplay = ({
    children
}: {
    children: React.ReactNode;
}) => <div className="search-result-card__result-container">{children}</div>;
